import {
  startOfDay,
  endOfDay,
  subDays,
  format,
  addDays,
  addWeeks,
  addMonths,
} from "date-fns";

export const DATE_RANGES = {
  WEEK: "7days",
  MONTH: "30days",
  YEAR: "12months",
} as const;

export type DateRange = (typeof DATE_RANGES)[keyof typeof DATE_RANGES];

export const DATE_RANGE_TO_API_PERIOD: Record<DateRange, string> = {
  [DATE_RANGES.WEEK]: "last7days",
  [DATE_RANGES.MONTH]: "last30days",
  [DATE_RANGES.YEAR]: "last12months",
};

export const DATE_RANGE_TO_INTERVAL: Record<
  DateRange,
  "day" | "week" | "month"
> = {
  [DATE_RANGES.WEEK]: "day",
  [DATE_RANGES.MONTH]: "day",
  [DATE_RANGES.YEAR]: "month",
};

export const DATE_RANGE_TO_LABEL: Record<DateRange, string> = {
  [DATE_RANGES.WEEK]: "Last 7 Days",
  [DATE_RANGES.MONTH]: "Last 30 Days",
  [DATE_RANGES.YEAR]: "Last 12 Months",
};

export const getDateRangeForPeriod = (period: DateRange) => {
  const today = new Date();
  const days = parseInt(period);

  return {
    start: startOfDay(subDays(today, days)),
    end: endOfDay(today),
  };
};

export const generateDateLabels = (period: DateRange): string[] => {
  const { start, end } = getDateRangeForPeriod(period);
  const interval = DATE_RANGE_TO_INTERVAL[period];
  const labels: string[] = [];
  let currentDate = start;

  while (currentDate <= end) {
    labels.push(format(currentDate, "MMM d"));
    currentDate =
      interval === "day"
        ? addDays(currentDate, 1)
        : interval === "week"
          ? addWeeks(currentDate, 1)
          : addMonths(currentDate, 1);
  }

  return labels;
};

export const getTimeAgo = (date: Date): string => {
  const now = new Date();
  const diffInMinutes = Math.floor((now.getTime() - date.getTime()) / 60000);

  if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
  if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
  return format(date, "MMM d");
};
